import React from "react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";

export default function MentionsLegales() {
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <section className="bg-white pt-20 pb-10">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto text-center mb-10">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Mentions Légales
              </h1>
            </div>
            <div className="prose prose-blue max-w-none text-justify">
              <p>
                <strong>MENTIONS LEGALES :</strong>
              </p>
              <p>
                Conformément aux dispositions des articles 6-III et 19 de la Loi
                n° 2004-575 du 21 juin 2004 pour la Confiance dans l'économie
                numérique, dite L.C.E.N., nous portons à la connaissance des
                utilisateurs et visiteurs du site : www.jm-interim.com les
                informations suivantes :
              </p>
              <h2>ÉDITEUR</h2>
              <p>
                Le site www.jm-interim.com est la propriété exclusive de SAS J'm
                Intérim, qui l'édite.
              </p>
              <p>
                <strong>J'm Intérim</strong>
                <br />
                SAS au capital de 80 000,00 €<br />
                Tél : 0180882135
                <br />
                Tour d'Asnières, 4 Av. Laurent Cély, Hall A, 92600
                Asnières-sur-Seine
                <br />
                RCS Nanterre B 919 125 518 n°91912551800010
                <br />
                TVA intracommunautaire : FR52919125518
                <br />
                Email : communication@jm-interim.com
              </p>
              <p>
                Directeur de la publication : Service communication
                <br />
                Contact : communication@jm-interim.com
              </p>
              <h2>HÉBERGEMENT</h2>

              <p>Hébergeur : Linode LLC, une société du groupe Akamai</p>

              <p>
                Siège social : 249 Arch Street, Philadelphia, PA 19106,
                États-Unis
              </p>

              <p>
                Site web :
                <a
                  href="https://www.linode.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linode.com
                </a>
              </p>

              <p>Téléphone (USA) : +1 609-380-7100</p>

              <p>
                Les données sont hébergées par Linode sur des serveurs situés
                dans l’Union européenne et sont soumises aux garanties de
                sécurité et de confidentialité mises en place par Linode/Akamai.
                Pour plus d’informations, consulter leur politique de
                confidentialité :
                <a
                  href="https://www.linode.com/legal-privacy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://www.linode.com/legal-privacy/
                </a>
              </p>

              <h2>DESCRIPTION DES SERVICES FOURNIS</h2>
              <p>
                Le site a pour objet de fournir une information sur les
                activités de la société. Les informations sont aussi précises
                que possible mais peuvent évoluer et ne sont pas exhaustives.
              </p>
              <h2>PROPRIÉTÉ INTELLECTUELLE ET CONTREFAÇONS</h2>
              <p>
                Le site est propriété de J'm Intérim ou utilisé sous licence.
                Toute reproduction sans autorisation est interdite.
              </p>
              <h2>LIENS HYPERTEXTES ET COOKIES</h2>
              <p>
                Le site peut contenir des liens vers d'autres sites. Le site
                peut installer des cookies pour des raisons techniques ou
                statistiques. Vous pouvez configurer votre navigateur pour les
                gérer.
              </p>
              <h2>PROTECTION DES DONNÉES PERSONNELLES</h2>
              <p>
                Le site ne collecte des données personnelles que pour certains
                services. Conformément à la loi, tout utilisateur dispose d'un
                droit d'accès, de rectification, suppression et opposition.
              </p>
              <p>
                Aucune information n'est cédée à des tiers sans consentement. Le
                site est conforme au RGPD. Pour toute demande :
                communication@jm-interim.com
              </p>
              <p>
                Les bases de données sont protégées par la loi du 1er juillet
                1998 transposant la directive 96/9 du 11 mars 1996.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
